import React from 'react';
import PropTypes from 'prop-types';
import { LohRegistrationPanel } from '@strava/loh-registration-panel-ui';
import Microfrontend from '../../../Microfrontend';
import StravaPackageContextProviders from '../../../StravaPackageContextProviders';
import styles from './AccountSignupFormV2.scss';

const AccountSignupFormV2 = ({
  authorizationUrls,
  flashMessage,
  config,
  reCaptchaSiteKey,
  honeyPot,
  isPremium,
  formAuthToken
}) => {
  const urlParams = new URLSearchParams(window.location.search);
  const forceMfe = urlParams.get('force_mfe');
  const forcePackage = urlParams.get('force_package');

  const useMfe = forceMfe && !forcePackage;

  const props = {
    authorizationUrls,
    flashMessage,
    config,
    reCaptchaSiteKey,
    honeyPot,
    isPremium,
    formAuthToken
  };

  return (
    <div className={styles.container}>
      {useMfe ? (
        <Microfrontend
          url="http://localhost:8082/remoteEntry.js"
          scope="strava_loh_registration_panel_wrapper"
          component="./LohRegistrationPanelWrapper"
          appContext={props}
        />
      ) : (
        <StravaPackageContextProviders>
          <LohRegistrationPanel {...props} />
        </StravaPackageContextProviders>
      )}
    </div>
  );
};

AccountSignupFormV2.defaultProps = {
  flashMessage: null
};

AccountSignupFormV2.propTypes = {
  flashMessage: PropTypes.string,
  config: PropTypes.shape({
    appleEnabled: PropTypes.bool.isRequired,
    appleState: PropTypes.string.isRequired // https://developer.apple.com/documentation/sign_in_with_apple/clientconfigi/3230956-state
  }).isRequired,
  authorizationUrls: PropTypes.shape({
    google: PropTypes.string.isRequired,
    facebook: PropTypes.string.isRequired
  }).isRequired,
  honeyPot: PropTypes.string.isRequired,
  isPremium: PropTypes.bool.isRequired,
  reCaptchaSiteKey: PropTypes.string.isRequired,
  formAuthToken: PropTypes.string.isRequired
};

export default AccountSignupFormV2;
